import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../HomePageSkeleton/HomePageSkeleton.css"; // Custom styles

const AboutSke = () => {
  return (
    <div className="homepage-skeleton">
      {/* Hero Section */}
      <div className="ske-hero-section">
        <div className="ske-hero-right">
          <Skeleton style={{ width: "100%" }} height={400} />
        </div>
        <div className="ske-hero-left">
          <Skeleton width={140} height={18} />
          <Skeleton height={36} />
          <Skeleton height={200} />
          <Skeleton width={`80%`} height={18} />
          <Skeleton width={130} height={40} borderRadius={20} />
        </div>
      </div>
    </div>
  );
};

export default AboutSke;
